import TuneIcon from '@mui/icons-material/Tune';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface AdvancedSectionProps {
  title?: string;
  description: string;
  children: ReactNode;
}

const AdvancedSection = ({ title = 'Avanzado', description, children }: AdvancedSectionProps) => {
  return (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        border: 'none',
        borderRadius: 2,
        bgcolor: 'action.hover',
        '&::before': { display: 'none' },
        '&.Mui-expanded': { bgcolor: 'action.hover' },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: 'text.secondary' }} />}
        sx={{
          px: 2,
          py: 0.5,
          minHeight: 56,
          borderRadius: 2,
          '&.Mui-expanded': { minHeight: 56 },
          '& .MuiAccordionSummary-content': { my: 1 },
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <TuneIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
          <Stack spacing={0}>
            <Typography variant="body2" fontWeight={600}>
              {title}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {description}
            </Typography>
          </Stack>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 2, pt: 0, pb: 2 }}>
        <Stack spacing={2}>{children}</Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default AdvancedSection;
